export var AutoLockType;
(function (AutoLockType) {
    AutoLockType["DEFAULT"] = "default";
    AutoLockType["DEVICE_LOCK"] = "locked";
    AutoLockType["IDLE_LOCK"] = "idle";
})(AutoLockType || (AutoLockType = {}));
